import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M1.5 3.75v16.5h21V3.75h-21ZM3 5.25h18v10.43l-3.96-3.985-.54-.539-3.398 3.399-4.313-4.36-.539-.539L3 14.906V5.25Zm15 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3Zm-9.75 5.04 6.89 6.96H3v-1.71l5.25-5.25Zm8.25 1.5 4.5 4.5v.96h-3.727l-3.117-3.14 2.344-2.32Z" />
  </svg>
);

export default icon;
